// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file Navaid.proto (package Navaid, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Sectorization } from "./Sectorization_pb";
import { file_Sectorization } from "./Sectorization_pb";
import type { ActualScreeningAngle } from "./ActualScreeningAngle_pb";
import { file_ActualScreeningAngle } from "./ActualScreeningAngle_pb";
import type { Procedure } from "./Procedure_pb";
import { file_Procedure } from "./Procedure_pb";
import type { AirSpaceBoundary } from "./AirSpaceBoundary_pb";
import { file_AirSpaceBoundary } from "./AirSpaceBoundary_pb";
import type { NavaidFile } from "./NavaidFile_pb";
import { file_NavaidFile } from "./NavaidFile_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Navaid.proto.
 */
export const file_Navaid: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_Sectorization, file_ActualScreeningAngle, file_Procedure, file_AirSpaceBoundary, file_NavaidFile]);

/**
 * @generated from message Navaid.Navaid
 */
export type Navaid = Message<"Navaid.Navaid"> & {
  /**
   * @generated from field: google.protobuf.StringValue antennatype = 1;
   */
  antennatype?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue antheight = 2;
   */
  antheight?: number;

  /**
   * @generated from field: google.protobuf.StringValue arinc424fom = 3;
   */
  arinc424fom?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue bias = 4;
   */
  bias?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue cableloss = 5;
   */
  cableloss?: number;

  /**
   * @generated from field: google.protobuf.StringValue channel = 6;
   */
  channel?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue cone = 7;
   */
  cone?: number;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 8;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue declaredeirp = 9;
   */
  declaredeirp?: number;

  /**
   * @generated from field: google.protobuf.BoolValue defaultadded = 10;
   */
  defaultadded?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue dmetacanclass = 11;
   */
  dmetacanclass?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue doc = 12;
   */
  doc?: number;

  /**
   * @generated from field: google.protobuf.Timestamp dueforreplacement = 13;
   */
  dueforreplacement?: Timestamp;

  /**
   * @generated from field: google.protobuf.DoubleValue elevation = 14;
   */
  elevation?: number;

  /**
   * @generated from field: google.protobuf.StringValue equipmenttype = 15;
   */
  equipmenttype?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue fligthinspectioninterval = 16;
   */
  fligthinspectioninterval?: number;

  /**
   * @generated from field: google.protobuf.StringValue icaocc = 17;
   */
  icaocc?: string;

  /**
   * @generated from field: google.protobuf.Int32Value id = 18;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.StringValue infosrce = 19;
   */
  infosrce?: string;

  /**
   * @generated from field: google.protobuf.Timestamp infoupdate = 20;
   */
  infoupdate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp lastinspection = 21;
   */
  lastinspection?: Timestamp;

  /**
   * @generated from field: google.protobuf.DoubleValue latitude = 22;
   */
  latitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue longitude = 23;
   */
  longitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue losthreshold = 24;
   */
  losthreshold?: number;

  /**
   * @generated from field: google.protobuf.StringValue manufacturer = 25;
   */
  manufacturer?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue maxaltitude = 26;
   */
  maxaltitude?: number;

  /**
   * @generated from field: google.protobuf.Int32Value maxload = 27;
   */
  maxload?: number;

  /**
   * @generated from field: google.protobuf.BoolValue meetingpost1989sarps = 28;
   */
  meetingpost1989sarps?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue model = 29;
   */
  model?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue mtbo = 30;
   */
  mtbo?: number;

  /**
   * @generated from field: google.protobuf.StringValue name = 31;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue navaidid = 32;
   */
  navaidid?: string;

  /**
   * @generated from field: google.protobuf.StringValue navaidtype = 33;
   */
  navaidtype?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue ndbfrequency = 34;
   */
  ndbfrequency?: number;

  /**
   * @generated from field: google.protobuf.StringValue notes = 35;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.BoolValue notupdate = 36;
   */
  notupdate?: boolean;

  /**
   * @generated from field: google.protobuf.DoubleValue offsetdist = 37;
   */
  offsetdist?: number;

  /**
   * @generated from field: google.protobuf.Timestamp operationalsince = 38;
   */
  operationalsince?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue operationalstatus = 39;
   */
  operationalstatus?: string;

  /**
   * @generated from field: google.protobuf.StringValue operator = 40;
   */
  operator?: string;

  /**
   * @generated from field: google.protobuf.Timestamp plannedinspection = 41;
   */
  plannedinspection?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp plannedremoval = 42;
   */
  plannedremoval?: Timestamp;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 43;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue quiescentsquitterrate = 44;
   */
  quiescentsquitterrate?: number;

  /**
   * @generated from field: google.protobuf.StringValue sectorizationtext = 45;
   */
  sectorizationtext?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue transmoutpower = 46;
   */
  transmoutpower?: number;

  /**
   * @generated from field: google.protobuf.BoolValue updated = 47;
   */
  updated?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue userdefined = 48;
   */
  userdefined?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue usesectorization = 49;
   */
  usesectorization?: boolean;

  /**
   * @generated from field: google.protobuf.DoubleValue vordocmaxrange = 50;
   */
  vordocmaxrange?: number;

  /**
   * @generated from field: google.protobuf.Timestamp vordueforreplace = 51;
   */
  vordueforreplace?: Timestamp;

  /**
   * @generated from field: google.protobuf.DoubleValue vorinpectioninterval = 52;
   */
  vorinpectioninterval?: number;

  /**
   * @generated from field: google.protobuf.Timestamp vorlastinsp = 53;
   */
  vorlastinsp?: Timestamp;

  /**
   * @generated from field: google.protobuf.DoubleValue vorlatitude = 54;
   */
  vorlatitude?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue vorlongitude = 55;
   */
  vorlongitude?: number;

  /**
   * @generated from field: google.protobuf.StringValue vormanufacturer = 56;
   */
  vormanufacturer?: string;

  /**
   * @generated from field: google.protobuf.StringValue vormodel = 57;
   */
  vormodel?: string;

  /**
   * @generated from field: google.protobuf.Timestamp voroperationalsince = 58;
   */
  voroperationalsince?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue voroperstatus = 59;
   */
  voroperstatus?: string;

  /**
   * @generated from field: google.protobuf.Timestamp vorplannedinspection = 60;
   */
  vorplannedinspection?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vorplannedremoval = 61;
   */
  vorplannedremoval?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue vortype = 62;
   */
  vortype?: string;

  /**
   * @generated from field: google.protobuf.StringValue antennaModelName = 63;
   */
  antennaModelName?: string;

  /**
   * @generated from field: repeated Sectorization.Sectorization sectorizations = 64;
   */
  sectorizations: Sectorization[];

  /**
   * @generated from field: repeated ActualScreeningAngle.ActualScreeningAngle actualScreeningAngle = 65;
   */
  actualScreeningAngle: ActualScreeningAngle[];

  /**
   * @generated from field: google.protobuf.BoolValue critical = 66;
   */
  critical?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue isItu = 67;
   */
  isItu?: boolean;

  /**
   * @generated from field: repeated NavaidFile.NavaidFile navaidFiles = 68;
   */
  navaidFiles: NavaidFile[];

  /**
   * @generated from field: repeated Procedure.Procedure associatedProcedures = 69;
   */
  associatedProcedures: Procedure[];

  /**
   * @generated from field: repeated Procedure.Procedure associatedProceduresCritical = 70;
   */
  associatedProceduresCritical: Procedure[];

  /**
   * @generated from field: repeated AirSpaceBoundary.AirSpaceBoundary associatedAirspaceBoundaries = 71;
   */
  associatedAirspaceBoundaries: AirSpaceBoundary[];
};

/**
 * Describes the message Navaid.Navaid.
 * Use `create(NavaidSchema)` to create a new message.
 */
export const NavaidSchema: GenMessage<Navaid> = /*@__PURE__*/
  messageDesc(file_Navaid, 0);

